/*@ngInject*/
const SendChatMessageRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.sendChatMessage = function (submissionId, chatMessage) {
        let url = '/rest/ChatMessage?submissionId=' + submissionId;

        return this.post(url, chatMessage);
    };
};

angular.module('gw-um-submission')
    .service('sendChatMessageRepository', SendChatMessageRepository);
